export default "__VITE_ASSET__CyKs$RdS__"